<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import LaisCard from 'dashboard/components-next/LaisCard.vue';

// Faixa superior do relatório: nota de desempenho, atividades, visualizações e
// visitas agendadas do anúncio, com a cópia vinda do backend quando existir.
const props = defineProps({
  copy: { type: Object, default: () => ({}) },
  score: { type: Number, default: 0 },
  activities: { type: Number, default: 0 },
  views: { type: Number, default: 0 },
  scheduledVisits: { type: Number, default: 0 },
});

const activityCards = computed(() => [
  {
    title: props.copy.score_card_title || 'Nota de desempenho',
    value: `${props.score}/100`,
    description:
      props.copy.score_card_text ||
      'A nota de desempenho é referente a um conjunto de ações que impactam a visibilidade do imóvel.',
  },
  {
    title: props.copy.activity_card_title || 'Atividades do anúncio',
    value: props.activities,
    description:
      props.copy.activity_card_text ||
      'Informações referente aos últimos 30 dias, comparando a imóveis similares.',
  },
  {
    title: props.copy.title_views || 'Visualizações do anúncio',
    value: props.views,
    description:
      props.copy.activity_card_text_small || 'Comparando a imóveis similares.',
  },
  {
    title: props.copy.title_visits || 'Visitas agendadas',
    value: props.scheduledVisits,
    description:
      props.copy.activity_card_text_small || 'Comparando a imóveis similares.',
  },
]);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div class="mb-6 grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
    <LaisCard v-for="card in activityCards" :key="card.title" density="tight">
      <p
        class="text-[12px] font-semibold uppercase tracking-wide text-lais-text-muted"
      >
        {{ card.title }}
      </p>
      <p
        class="mt-3 text-[26px] font-semibold text-lais-primary font-redHatDisplay"
      >
        {{ card.value }}
      </p>
      <p class="mt-2 text-[13px] leading-relaxed text-lais-text-body">
        {{ card.description }}
      </p>
    </LaisCard>
  </div>
</template>
